import { render, staticRenderFns } from "./transferWaiting.vue?vue&type=template&id=f9ff9efe&scoped=true"
import script from "./transferWaiting.vue?vue&type=script&lang=js"
export * from "./transferWaiting.vue?vue&type=script&lang=js"
import style0 from "./transferWaiting.vue?vue&type=style&index=0&id=f9ff9efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ff9efe",
  null
  
)

export default component.exports